import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.25 8.5C18.6642 8.5 19 8.83579 19 9.25L19 18.25C19 18.6642 18.6642 19 18.25 19L9.25 19C8.83579 19 8.5 18.6642 8.5 18.25C8.5 17.8358 8.83579 17.5 9.25 17.5L16.4393 17.5L6.21967 7.28033C5.92678 6.98744 5.92678 6.51256 6.21967 6.21967C6.51256 5.92678 6.98744 5.92678 7.28033 6.21967L17.5 16.4393L17.5 9.25C17.5 8.83579 17.8358 8.5 18.25 8.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgArrowDownRight;
